import formatBaseUrl from 'ui-forms-embed-components-reporting/reporting/utils/formatBaseUrl';
import buildErrorPayload from 'ui-forms-embed-components-reporting/reporting/internal/buildErrorPayload';
const reportErrorToLogFetch = (level = '', error, options = {}) => {
  const payload = buildErrorPayload(level, error, options);
  void fetch(formatBaseUrl(options), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload),
    keepalive: true
  });
};
export default reportErrorToLogFetch;